import React from 'react'
import PropTypes from 'prop-types'

import { DashboardModuleListItem } from '@domain-group/suit-theme'

import useFontFamily from '@hooks/useFontFamily'

const FontFamilyListItem = (props) => {
  const { fontFamily: initFontFamily } = props

  const fontFamilyPayload = useFontFamily(initFontFamily)
  const {
    callbacks: { createOrEditFontFamily },
    fontFamily: { font_count, title },
  } = fontFamilyPayload

  return (
    <DashboardModuleListItem onClick={() => createOrEditFontFamily()} title={title}>
      <DashboardModuleListItem.TertiaryText>
        {font_count === 1 ? `${font_count} Font` : `${font_count || 0} Fonts`}
      </DashboardModuleListItem.TertiaryText>
    </DashboardModuleListItem>
  )
}

FontFamilyListItem.propTypes = {
  fontFamily: PropTypes.object.isRequired,
}

export default FontFamilyListItem
